import React from 'react';
import classNames from 'classnames/bind';
import { Helmet } from 'react-helmet';
import styles from './UserDataDeletion.module.scss';

import ChatAccountDeletionForm from './components/ChatAccountDeletionForm';

const cn = classNames.bind(styles);

const ChatUserDataDeletion: React.FC = () => {
  return (
    <div className={cn('layout_container')}>
      <Helmet>
        <title>AngkorLife Deletion Req</title>
        <meta name="description" content="AngkorLife User Data Deletion Request" />
        <meta name="keywords" content="AngkorLife, UserData, Deletion" />
        <meta property="og:title" content="AngkorLife User Data Deletion" />
        <meta property="og:description" content="This is AngkorLife User Data Deletion Request Page." />
        <meta property="og:type" content="website" />
      </Helmet>
      <h2 className={cn('header_title')}>AngkorLife User Data Deletion Request</h2>

      <main>
        {/* Instruction */}
        <section className={cn('instruction_section')}>
          <header>
            <h2 className={cn('instruction_title')}>Instructions for Requesting Data Deletion</h2>
          </header>

          <div className={cn('instruction_content_wrap')}>
            <h2 className={cn('content_bold')}>Step 1:</h2>
            <span> Fill out the form below to request data deletion.</span>
          </div>

          <div className={cn('instruction_content_wrap')}>
            <h2 className={cn('content_bold')}>Step 2:</h2>
            <span>Enter your ID and the phone number you used. (SMS verification will be performed)</span>
          </div>

          <div className={cn('instruction_content_wrap')}>
            <h2 className={cn('content_bold')}>Step 3:</h2>
            <span>Once the information is verified, your data deletion request will be processed.</span>
          </div>
        </section>

        <ChatAccountDeletionForm />
      </main>
    </div>
  );
};

export default ChatUserDataDeletion;
